import React from 'react';
import PropTypes from 'prop-types';
import IconWithTooltip from '../IconWithTooltip';
import IconInfo from '../../assets/info.svg';

const TooltipContainer = ({
                            customIconClassName,
                            customTooltipClassName,
                            label
                          }) => (
  <IconWithTooltip
    icon={IconInfo}
    place="top"
    effect="solid"
    customIconClassName={customIconClassName}
    customTooltipClassName={customTooltipClassName}
  >
    {label}
  </IconWithTooltip>
);

TooltipContainer.propTypes = {
  customIconClassName: PropTypes.string,
  customTooltipClassName: PropTypes.string,
};

export default TooltipContainer;
